import { Pipe, PipeTransform } from '@angular/core';
import { FunctionUtil } from '../utils';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  transform(value: number): string {
    return FunctionUtil.formatFileSize(value);
  }

}
